import { TabsTheme } from '../../types';

export const TABS_DEFAULT_THEME: TabsTheme = {
    variant: {
        default: {
            underlineHeight: 4,
            underlineRounded: true,
            size: {
                s: {
                    typographyVariant: 'heading.2xs',
                    padding: {
                        x: 6,
                        y: 6,
                    },
                    spacing: 30,
                },
                m: {
                    typographyVariant: 'heading.2xs',
                    padding: {
                        x: 8,
                        y: 10,
                    },
                    spacing: 40,
                },
                l: {
                    typographyVariant: 'heading.2xs',
                    padding: {
                        x: 12,
                        y: 16,
                    },
                    spacing: 50,
                },
            },
            defaultColor: 'primary.base',
        },
        hero: {
            underlineHeight: 6,
            underlineRounded: true,
            size: {
                s: {
                    typographyVariant: 'hero.s',
                    padding: {
                        x: 20,
                        y: 8,
                    },
                    spacing: 0,
                },
                m: {
                    typographyVariant: 'hero.m',
                    padding: {
                        x: 24,
                        y: 12,
                    },
                    spacing: 0,
                },
                l: {
                    typographyVariant: 'hero.l',
                    padding: {
                        x: 32,
                        y: 16,
                    },
                    spacing: 0,
                },
            },
            defaultColor: 'primary.base',
        },
    },
};
